var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 6.80382L8.08085 4.055C8.83076 3.30509 9.20571 2.93014 9.61951 2.62814C10.4685 2.00851 11.4532 1.60062 12.4917 1.43843C12.9979 1.35938 13.5281 1.35938 14.5887 1.35938C14.6441 1.35938 14.6654 1.38479 14.6654 1.43607C14.6654 2.4966 14.6654 3.02687 14.5863 3.53301C14.4241 4.5715 14.0162 5.55622 13.3966 6.40523C13.0946 6.81903 12.7196 7.19398 11.9697 7.94389L9.22092 10.6927",
    stroke: "#A2A2B8",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89268 5.42496C5.75741 5.42496 4.33055 5.18447 3.26823 5.6245C2.48984 5.94692 1.91706 6.69349 1.33203 7.27851L3.53601 8.22308C4.12009 8.47339 3.76303 9.21047 3.66634 9.69393C3.5586 10.2327 3.56461 10.2525 3.95309 10.641L5.38375 12.0717C5.77223 12.4601 5.79208 12.4661 6.3308 12.3584C6.81427 12.2617 7.55135 11.9047 7.80166 12.4887L8.74623 14.6927C9.33125 14.1077 10.0778 13.5349 10.4002 12.7565C10.8403 11.6942 10.5998 10.2673 10.5998 9.13206",
    stroke: "#A2A2B8",
    strokeWidth: 1.14286,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6452 4.19028C12.8683 3.96713 12.8683 3.60532 12.6452 3.38216C12.422 3.159 12.0602 3.159 11.8371 3.38216L12.6452 4.19028ZM10.5946 4.62458C10.3715 4.84774 10.3715 5.20955 10.5946 5.43271C10.8178 5.65586 11.1796 5.65586 11.4028 5.43271L10.5946 4.62458ZM12.2411 3.78622L11.8371 3.38216L10.5946 4.62458L10.9987 5.02865L11.4028 5.43271L12.6452 4.19028L12.2411 3.78622ZM9.33203 2.69531L9.31509 3.26649C10.4911 3.30137 11.3174 3.65624 11.8591 4.21134C12.4029 4.76866 12.7278 5.59763 12.7609 6.71225L13.332 6.69531L13.9032 6.67837C13.8642 5.36204 13.4732 4.22911 12.6771 3.4132C11.8788 2.59509 10.7412 2.16543 9.34897 2.12414L9.33203 2.69531Z",
    fill: "#A2A2B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 13.3594L7.33203 14.026",
    stroke: "#A2A2B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 8.03125L2 8.69792",
    stroke: "#A2A2B8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.9d2de11ddbd8332d69a90d37ef5c4fa5.svg";
export { ForwardRef as ReactComponent };